import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { OtherUseByConservationTypeSyncResultDto } from '../dtos/other-use-by-conservation-type/models';

@Injectable({
  providedIn: 'root',
})
export class OtherUseByConservationTypeOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  obtainOtherUseByConservationTypeFromGis = (cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseByConservationTypeSyncResultDto>({
      method: 'POST',
      url: '/api/orchestrator/other-uses-by-conservation-type/sync-from-gis',
    },
    { apiName: this.apiName,...config });
}